export default "__VITE_ASSET__Cr$HnKvi__"